<template>
  <div class="floating-contact-buttons">
    <!-- Facebook 联系按钮 -->
    <a 
      href="https://www.facebook.com/profile.php?id=61577205355724" 
      target="_blank" 
      class="floating-button facebook-button"
      :title="t('facebook')"
    >
      <img src="../assets/facebook.png" :alt="t('facebook')" class="button-icon" />
    </a>
    
    <!-- WhatsApp 联系按钮 -->
    <a 
      href="whatsapp://send?phone=+85266860815" 
      target="_blank" 
      class="floating-button whatsapp-button"
      :title="t('whatsapp')"
    >
      <img src="../assets/whatsapp.png" :alt="t('whatsapp')" class="button-icon" />
    </a>
    
    <!-- Instagram 联系按钮 -->
    <a 
      href="https://www.instagram.com/dr_moto_ev_hk_ltd/" 
      target="_blank" 
      class="floating-button instagram-button"
      :title="t('instagram')"
    >
      <img src="../assets/Instagram.png" :alt="t('instagram')" class="button-icon" />
    </a>
    
    <!-- 体验申请按钮 -->
    <button 
      class="floating-button application-button"
      :title="t('application')"
      @click="goToApplicationForm"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
        <polyline points="14 2 14 8 20 8"></polyline>
        <line x1="16" y1="13" x2="8" y2="13"></line>
        <line x1="16" y1="17" x2="8" y2="17"></line>
        <polyline points="10 9 9 9 8 9"></polyline>
      </svg>
    </button>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';

// 使用i18n获取翻译文本
const { t } = useI18n();
const router = useRouter();

// 跳转到体验申请表单
const goToApplicationForm = () => {
  router.push('/application-form');
};
</script>

<style scoped>
/* 修改前 */
.floating-contact-buttons {
    position: fixed;
    top: 65%;
    right: 30px;
    transform: translateY(-50%);
    display: flex;
    flex-direction: column;
    gap: 15px;
    z-index: 9999;
    pointer-events: all;
  }

.floating-button {
  width: 55px;
  height: 55px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.95);
  border: 2px solid #12aa4a;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
  text-decoration: none;
  opacity: 0.95;
  backdrop-filter: blur(5px);
}

.floating-button:hover {
  transform: translateY(-5px) scale(1.05);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
  opacity: 1;
}

.button-icon {
  width: 28px;
  height: 28px;
  object-fit: contain;
  transition: transform 0.3s ease;
}

.floating-button:hover .button-icon {
  transform: scale(1.1);
}

/* 为每个按钮添加独特的悬停效果 */
.facebook-button:hover {
  background-color: #1877F2;
}

.whatsapp-button:hover {
  background-color: #25D366;
}

.instagram-button:hover {
  background-color: #E1306C;
}

/* 体验申请按钮样式 */
.application-button:hover {
  background-color: #12aa4a;
  color: white;
}

/* 平板端响应式样式更新 */
@media (max-width: 768px) {
  .floating-contact-buttons {
    top: 65%;
    right: 20px;
    transform: translateY(-50%);
    gap: 10px;
  }
}

/* 手机端响应式样式更新 */
@media (max-width: 480px) {
  .floating-contact-buttons {
    top: 65%;
    right: 15px;
    transform: translateY(-50%);
  }
}
</style>